
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import "./style.css";
import logoImg from "../../../assets/imgs/DUE-FACTORY.png"
import '../../../CentralMenu/ScoreGauge.css';
import exp_img from "../../../assets/imgs/Experian_logo.png";
import back_1_support from "../../../assets/imgs/Gauge/back1Support.png";
import back_2_support from "../../../assets/imgs/Gauge/back2Support.png";
import back_3_support from "../../../assets/imgs/Gauge/back3Support.png";
import back_4_support from "../../../assets/imgs/Gauge/back4Support.png";
import { formatTimestampForLastUpdated, generic_stacked_record } from '../../../utils/GenericInsightStack';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";


import userDetailIcon from "../../../assets/img/userDetailIcon.png";
import paymentIconNew from "../../../assets/img/paymentIconNew.png";
import creditUtilisationIconNew from "../../../assets/img/creditUtilisationIconNew.png";
import EnquiryIconNew from "../../../assets/img/EnquiryIconNew.png";
import creditMixIconNew from "../../../assets/img/creditMixIconNew.png";

import indexPageImg4 from "../../../assets/img/credImg1.png";
import indexPageImg6 from "../../../assets/img/tipsIcon.png";
import indexPageImg7 from "../../../assets/img/accountIcon.png";
import indexPageImg8 from "../../../assets/img/bankNoteIcon.png";
import enquiryIcon from "../../../assets/img/enquiryIcon.png"
import ReportAnErrorIcon from "../../../assets/img/reportAnError.png"
import rightArrowIcon from "../../../assets/img/right-arrow-icon.png";

import paymentMark1 from "../../../assets/genInsImgs/mark1.png";
import paymentMark2 from "../../../assets/genInsImgs/mark2.png";
import paymentMark3 from "../../../assets/genInsImgs/mark3.png";
import paymentMark4 from "../../../assets/genInsImgs/mark4.png";

import Chart from 'react-google-charts';
import { GET_INSIGHTS, postGenericInsights, profileApiData } from '../../../service/ApiList';
import { BANK_IMG_STACK } from '../../../DashboardComponents/LoanCard';
const calculateNeedleAngle = (score) => {
    const minScore = 300;
    const maxScore = 900;
    const minAngle = -124;
    const maxAngle = 124;
    const scorePercentage = (score - minScore) / (maxScore - minScore);
    return minAngle + scorePercentage * (maxAngle - minAngle);
};
const ScoreGauge = ({ score, isLoading, lastUpdated }) => {
    const needleRef = useRef(null);
    const [animatedScore, setAnimatedScore] = useState(300); // Start from 300
    useEffect(() => {
        if (isLoading) return; // Wait until isLoading is false
        let currentScore = 300; // Starting score
        const interval = setInterval(() => {
            if (currentScore < score) {
                currentScore += 10; // Increment by 10
                setAnimatedScore(Math.min(currentScore, score)); // Update animated score
            } else {
                clearInterval(interval); // Stop animation at target score
            }
        }, 5);

        return () => clearInterval(interval); // Cleanup on unmount
    }, [score]);

    useEffect(() => {
        if (needleRef.current) {
            const needleAngle = calculateNeedleAngle(animatedScore);
            needleRef.current.style.transform = `translate(0%, -25%) rotate(${needleAngle}deg)`;
        }
    }, [animatedScore]);
    const checkColour = (Sc) => {
        if (Sc >= 300 && Sc < 700) {
            return `#f51111`;
        } else if (Sc >= 700 && Sc < 800) {
            return `#6dbc5d`;
        } else {
            return `#12a547`;
        }
    };
    return (<>
        <div className='pdf-score-gauge'>
            <img crossOrigin="anonymous" src={back_1_support} alt="logo" className='pdf-score-gauge-back-1' />
            <img crossOrigin="anonymous" src={back_2_support} alt="logo" className='pdf-score-gauge-back-2' />
            <img crossOrigin="anonymous" src={back_3_support} alt="logo" className='pdf-score-gauge-back-3' />
            <div
                ref={needleRef}
                className="main-score-guage-block-value-support-1 pdf-score-gauge-arrow"
            ></div>
            <div className="pdf-score-gauge-milestone-1">300</div>
            <div className="pdf-score-gauge-milestone-2">600</div>
            <div className="pdf-score-gauge-milestone-3">700</div>
            <div className="pdf-score-gauge-milestone-4">800</div>
            <div className="pdf-score-gauge-milestone-5">900</div>

            <img crossOrigin="anonymous" src={back_4_support} alt="logo" className='pdf-score-gauge-back-4' />
            <div className='pdf-score-gauge-back-5'> </div>
            <div className='pdf-score-gauge-values'>
                <div className='pdf-score-gauge-value-1'>{animatedScore}</div>
                <div
                    style={{ color: checkColour(animatedScore) }}
                    className='pdf-score-gauge-value-2'>
                    {score >= 800 ? 'Excellent' :
                        score >= 700 ? 'Good' :
                            score >= 600 ? 'Fair' : 'Bad'}
                </div>
            </div>



        </div>
    </>)
}

const LandingPage = ({ mainData }) => {
    return (<>
        <div >
            <div className='pdf-body-user-name' style={{ marginTop: 100 }}>Hello, {mainData?.userName}</div>
            <div className='pdf-body-user-info'>Here is your generated Smart Credit Insights</div>
            <div className='pdf-body-powered-by'>
                <span>Powered by</span>
                <img crossOrigin="anonymous" src={exp_img} alt="exp-img" />
            </div>
            <ScoreGauge
                score={mainData?.creditScore}
                isLoading={false}
                lastUpdated={mainData?.dateOfReport}
            />
            <div className='pdf-body-reported-date'>
                <div>
                    <p>Report Date:</p>
                    <span> {formatTimestampForLastUpdated(mainData?.dateOfReport)}</span>
                </div>
            </div>
            <p className='pdf-body-info-para'>
                {mainData?.creditRemarks}
            </p>
        </div>
    </>)
}

const LandingPage2 = () => {
    return (<>
        <div >
            <div className='pdf-body-user-name' style={{ marginTop: 100 }}>Hello, Gaurav Badgujar</div>
            <div className='pdf-body-user-info'>Here is your generated Smart Credit Insights</div>
        </div>
    </>)
}

const ReportIndexPage = () => {
    const elements = (el) => {
        return (<>
            <div className='pdf-report-index-page-element'>
                <img crossOrigin="anonymous" style={{ paddingTop: 10, height: el.height ? el.height : 25, width: 25 }} src={el.src} alt={el.src} />
                <div>
                    <span>{el.label}</span>
                    <p>
                        {el.para}
                    </p>
                </div>
                <span></span>
            </div>
        </>)
    }
    const iconStyle = { fontSize: 20, lineHeight: 20, color: "#033B52", marginTop: 10 };
    const tabs = [
        {
            key: "type_profile_details",
            label: "Profile Details",
            para: "Displays key personal and financial details like name, DOB, PAN, and contact info.",
            // icon: <IoMdTime style={{ ...iconStyle, strokeWidth: 10 }} />
            src: userDetailIcon,
            alt: "index page img 1",
        },
        {
            key: "type_payments",
            label: "Payments",
            // para: "Shows your history of timely or missed repayments across all credit accounts.",
            para: " Track your complete repayment record - every on-time payment and missed deadline that's shaping your credit score.",
            // icon: <VscGraphLine style={{ ...iconStyle, strokeWidth: .5 }} />
            src: paymentIconNew,
            alt: "index page img 2",
            height: 18
        },
        {
            key: "type_credit_utilisation",
            label: "Credit Utilization",
            // para: "Indicates the percentage of used credit versus your total available limit.",
            para: "Credit Utilisation shows what percentage of your total credit card limit you're currently using against the total limit.",
            // icon: <LuUsers style={{ ...iconStyle, strokeWidth: 2 }} />
            src: creditUtilisationIconNew,
            alt: "index page img 3",
        },
        {
            key: "type_accounts",
            label: "Credit Mix",
            // para: "Summarizes the variety of credit types like loans, cards, and mortgages.",
            para: "Credit Mix shows the variety of different credit types you have, such as unsecured loans, credit cards, and secured loans.",
            // icon: <MdOutlineSwitchAccount style={{ ...iconStyle, strokeWidth: 0 }} />
            src: creditMixIconNew,
            alt: "index page img 4",
        },
        {
            key: "type_enquiries",
            label: "Enquiries",
            // para: "Lists recent lender checks when you applied for loans or credit products.",
            para: "Enquiries shows recent credit checks made in last 90 days by lenders when you applied for loans or credit products.",
            // icon: <PiWarningCircleLight style={{ ...iconStyle, strokeWidth: 10 }} />
            src: EnquiryIconNew,
            alt: "index page img 5",
        },
    ]
    return (<>
        <div className='pdf-report-index-page'>
            <div className='pdf-report-index-page-head'>
                {/* Credit Insights */}
                Critical Impact Factors
            </div>
            <p className='pdf-report-index-page-head-para'>
                {/* These are the most critical factors impacting your credit score and report.
                For you to further improve on your credit score, these are the factors you
                need to carefully monitor and improve upon. We have shared below a
                detailed view of these factors against your credit score.
                Do read up and work with us to up your credit score! */}
                These insights represent the most significant elements currently
                affecting your overall credit score and the detailed information
                within your credit report. These are Payments, Credit Utlisation,
                Credit Mix, Enquries made in last 90 days and Profile.
            </p>
            <p className='pdf-report-index-page-head-para'>
                <ul className='pdf-report-index-page-head-para-li'>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        To achieve meaningful progress in enhancing your credit score,
                        these specific factors require your careful attention,
                        consistent monitoring, and strategic improvement efforts.
                    </li>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        Take time to thoroughly review and understand each factor,
                        as this knowledge will empower you to make informed financial
                        decisions moving forward.
                    </li>
                </ul>
            </p>

            {
                tabs.map((tab) =>
                    elements(tab)
                )
            }
        </div>
    </>)
}
const RequiredInfoPage = () => {
    return (<>
        <div className='pdf-report-index-page' >
            <div className="required-page-content">
                <div>What's inside:</div>
                <ul className="required-page-content-ul">
                    <li>
                        <b>Every credit account</b> – you've ever opened – from your first credit card to your latest personal loan
                    </li>
                    <li>
                        <b>Your payment track record</b> – the good months, the tough months, and everything in between
                    </li>
                    <li>
                        <b>Who's been checking on you</b> – every time someone pulled your credit report (and why that matters)
                    </li>
                    <li>
                        <b>Your current financial commitments</b> – how much you owe, to whom, and how you're managing it all
                    </li>
                </ul>


                <div className="required-page-section-title">Why this matters:</div>
                <p className="required-page-text">
                    Lenders spend less than 2 minutes reviewing your application. This summary is what they see first – and often,
                    it's what decides your fate. A strong summary opens doors to better interest rates, higher credit limits, and
                    faster approvals. A weak one? Well, you know how that story ends.
                </p>
                <p className="required-page-text">
                    Understanding this summary puts you in control. You'll see exactly what's working in your favor and what needs
                    fixing. No surprises, no rejections you didn't see coming – just a clear path to the credit score you deserve.
                </p>

                <p className="required-page-callout">Think of this as your financial mirror. Ready to look?</p>
            </div>

        </div>
    </>)
}
const PageWrapper = ({ children }) => {
    return (
        <div
            style={{
                // Pixels (at 96 DPI)	794 × 1123 px
                width: "794px", height: "1120px", padding: "10px",
                border: "1px solid #ccc",
                display: "flex", flexDirection: "column", boxSizing: "border-box",
                backgroundColor: "#fff", // Optional for better visibility,
                pageBreakAfter: "always",
                breakAfter: "page",
                // visibility: "hidden",
                // position: 'absolute'
            }}
            className='pdf-page'
        >
            <div
                style={{
                    height: "60px", display: "flex", alignItems: "center",
                    justifyContent: "space-between", padding: "0px", fontWeight: "bold",
                    backgroundColor: "#fff", margin: "10px 30px", borderBottom: "2px solid #3F85A2"
                }}
            >
                <img crossOrigin="anonymous" src={logoImg} alt="Logo" className="pdf-header-logo" />
                <h2 className="pdf-header-title">Smart Credit Insight Report</h2>
            </div>
            <div
                style={{
                    height: "1000px", overflow: "hidden",
                    display: "flex", flexDirection: "column", justifyContent: "flex-start",
                    padding: "10px",
                }}
            >
                {children}
            </div>

            {/* Footer Section */}
            <div
                style={{
                    height: "40px", borderTop: "1px solid #ccc",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "12px", backgroundColor: "#f8f8f8",
                }}
            >
                <p>© 2023 Due Factory , All rights reserved.</p>
            </div>
        </div>
    );
};


const PageBreakMediator = ({ children }) => {
    const pageRef = useRef(null);
    const [pages, setPages] = useState([]);
    const PAGE_HEIGHT = 940; // height for the content body section
    useEffect(() => {
        if (!pageRef.current) return;

        const container = pageRef.current.children[0];
        const containerStyle = container.getAttribute("style") || "";
        const nestedElements = Array.from(container.children);

        const nestedPage = [];
        let currentContent = [];
        let sum = 0;

        for (const element of nestedElements) {
            // Account for actual height including margin-bottom
            const elHeight = element.offsetHeight;
            const style = window.getComputedStyle(element);
            const marginBottom = parseFloat(style.marginBottom) || 0;
            const totalHeight = elHeight + marginBottom;


            if (sum + totalHeight <= (PAGE_HEIGHT - container.children.length)) {
                currentContent.push(element);
                sum += totalHeight;
            } else {
                nestedPage.push(currentContent);
                currentContent = [element];
                sum = totalHeight;
            }
        }


        if (currentContent.length > 0) {
            nestedPage.push(currentContent);
        }


        const generatedPages = nestedPage.map((item, index) => {
            const combinedHTML = item.map(el => el.outerHTML).join('');
            const finalHTML = `<div style="${containerStyle}">${combinedHTML}</div>`;

            return (
                <PageWrapper key={index}>
                    <div dangerouslySetInnerHTML={{ __html: finalHTML }} />
                </PageWrapper>
            );
        });
        setPages(generatedPages);
    }, [children]);


    return (
        <>
            {/* Hidden reference for height calculation */}
            <div style={{ visibility: "hidden", position: "absolute", top: 0, left: 0, width: "794px" }} ref={pageRef}>
                {children}
            </div>

            {/* Render sliced content */}
            {pages}
        </>
    );
};

const ProfileInfoPage = ({ mainData, isLoading, profileData }) => {
    const [addressDetails, setAddressDetails] = useState(mainData?.insightAddressDetails || []);
    const data = [
        { id: 1, label: "Email", value: profileData?.email || "-" },
        { id: 2, label: "Gender", value: [1, 2].includes(profileData?.gender) ? profileData.gender === 1 ? "Male" : "Female" : "-" },
        { id: 3, label: "DOB", value: profileData?.dob || "-" },
        { id: 4, label: "PAN", value: profileData?.pan || "-" },
    ]
    // useEffect(() => {
    //     const address = mainData?.insightAddressDetails;
    //     setAddressDetails(address)
    // }, [mainData, isLoading])

    return (<>
        <div className="profile-info-page-main">
            <div className='profile-info-page-head'>
                <img crossOrigin="anonymous" src={userDetailIcon} alt='info icons' />
                <span>Profile Details</span>
            </div>
            <p className='profile-info-page-head-para'>
                This section shows all contactable addresses, phone numbers, and
                essential details like name, date of birth, and identification information,
                ensuring your personal records are accurate and up to date.
            </p>
            <div className='profile-info-page-gen-info'>
                <p>{profileData?.name + " " + profileData?.surName}</p>
                <div className='profile-info-page-gen-info-elm'>
                    {data.map((item) =>
                        <div key={item.id}>
                            <span>{item.label}</span>
                            <p>{item.value}</p>
                        </div>
                    )}
                </div>
            </div>
            <div className='profile-info-page-sum-info'>
                <div>
                    {/* Credit Report Summary */}
                    Your Financial Snapshot - What Lenders See
                </div>
                <p>
                    {/* This credit report summarizes your financial activities,
                    including your credit accounts, payment history, and credit
                    inquiries, providing a snapshot of your creditworthiness. */}
                    This is your credit story in a nutshell - the exact same summary
                    that banks, NBFCs, and lenders review when you apply for a
                    loan or credit card. No fluff, no hidden details, just the
                    facts that determine whether you get approved or rejected.
                </p>
            </div>
            <RequiredInfoPage />
            <div className='profile-info-page-address-info-head'>
                <p style={{ width: 304 }}>Address</p>
                <p style={{ width: 180 }}>Reported By</p>
                <p style={{ width: 108 }}>Loan Category</p>
                <p style={{ width: 108 }}>Address Type</p>
            </div>
            {addressDetails.map((item, index) => (
                <div key={index} className='profile-info-page-address-info'>
                    <p style={{ width: 304 }}>{item.address}</p>
                    <p style={{ width: 180 }}>{item.subscriberName}</p>
                    <p style={{ width: 108 }}>{item.loanCategory}</p>
                    <p style={{ width: 108 }}>{item.addressType}</p>
                </div>
            ))}
        </div>
    </>)
}
const CreditScoreSteppedLineChart = ({ propData, mainLoading }) => {
    const scoreTrendLine = propData || []
    const [data, setData] = useState([
        ["Month", "Credit Score", { role: "tooltip", type: "string", p: { html: true } }, { role: "style" }],
        ["Sep 24", 205, "No Change"],
        ["Oct 24", 505, "Increase"],
    ]);
    const [graphRange, setGraphRange] = useState({ maxScore: 900, minScore: 600 })

    const scoreMapping = [
        { range: [0, 300], label: 'NEW TO CREDIT', color: "#FF5733" },
        { range: [300, 400], label: 'NEED ATTENTION', color: "#FF914D" },
        { range: [400, 500], label: 'POOR', color: "#FFB533" },
        { range: [500, 600], label: 'BELOW AVERAGE', color: "#FFDB33" },
        { range: [600, 700], label: 'AVERAGE', color: "#90CD4F" },
        { range: [700, 750], label: 'GOOD', color: "#90CD4F" },
        { range: [750, 800], label: 'GREAT', color: "#76FF33" },
        { range: [800, 900], label: 'EXCELLENT', color: "#4CAF50" }
    ];
    const getScoreLabelAndColor = (score) => {
        const result = scoreMapping.find(item => score >= item.range[0] && score < item.range[1]);
        return result ? { label: result.label, color: result.color } : { label: "UNKNOWN", color: "#000000" };
    };
    const getTrendColor = (trend) => {
        switch (trend) {
            case "Increase":
                return "#90CD4F"; // Green
            case "Decrease":
                return "#FF4040"; // Red
            case "No Change":
                return "#000000"; // Black
            default:
                return "#000000"; // Default black for unknown trends
        }
    };
    const findMaxMinScores = (data) => {
        const scores = data.slice(1).map(item => item[1]);
        const maxScore = Math.max(...scores);
        const minScore = Math.min(...scores);
        return { maxScore: maxScore >= 880 ? 900 : maxScore + 20, minScore: minScore - 20 };
    };

    useEffect(() => {
        const tempData = scoreTrendLine.slice(1).map(([month, creditScore, trend], index, arr) => {
            const { label, color } = getScoreLabelAndColor(creditScore);
            const trendColor = index == arr.length - 1 ? "#b8b1b1" : getTrendColor(trend);
            return [
                month,
                creditScore,
                `<div class="custom-tooltip">
                    ${month}
                    <br>
                    <span class="highlight">
                      ${label}
                       <br>
                      ${index == arr.length - 1 ? "Predicted" : ""}
                    </span>
                </div>`,
                trendColor
            ];
        });
        setData([
            ["Month", "Line 1", { role: "tooltip", type: "string", p: { html: true } }, { role: "style" }],
            ...tempData
        ]);
        setGraphRange(findMaxMinScores(scoreTrendLine));
    }, [propData]);


    function generateTicks(min, max, step = 10) {
        const ticks = [];
        for (let i = min; i <= max; i += step) {
            ticks.push(i);
        }
        return ticks;
    }

    const options = {
        title: "",
        hAxis: {
            title: "",
            ticks: data.slice(1).map(item => ({ v: item[0], f: item[0] })), // Ensure months appear on x-axis
            // slantedText: true, // Prevents overlap by angling text
        },
        vAxis: {
            title: "",
            viewWindow: { min: graphRange.minScore, max: graphRange.maxScore },
            ticks: generateTicks(graphRange.minScore, graphRange.maxScore),
        },
        legend: "none",
        lineWidth: 2,
        pointSize: 5,
        series: {
            0: { type: "line", lineWidth: 2, color: "black", pointShape: "circle", visibleInLegend: false },
        },
        chartArea: {
            left: 40, top: 20, right: 20, bottom: 30, width: "90%", height: "60%",
        },
        titleTextStyle: { fontSize: 12, fontFamily: "'Inter', serif", fontWeight: 400 },
        tooltip: { isHtml: true },
    };

    return (
        <div className='premium-report-first-dash-n-12-chart'>
            <div
                className='premium-report-first-dash-n-12-chart-1' style={{ minHeight: 200 }}>
                <Chart
                    chartType="ComboChart"
                    width={"100%"}
                    height="220px"
                    data={data}
                    options={options}
                    loader={<div>Loading information...</div>}
                />
            </div>
            <div className='premium-report-first-dash-n-12-chart-2' style={{ marginTop: 40 }}>
                <div>
                    <span style={{ background: "#90CD4F" }}></span>
                    <p>Increase</p>
                </div>
                <div>
                    <span style={{ background: "#FF4040" }}></span>
                    <p>Decrease</p>
                </div>
                <div>
                    <span style={{ background: "#000000" }}></span>
                    <p>No change</p>
                </div>
            </div>
        </div>
    );
};
const QuickTipsPage = () => {
    return (<>
        <div className='pdf-report-index-page'>
            <h2 className="rag-block-heading">Quick Wins – Your Credit Report Cheat Sheet</h2>

            <p className="rag-block-paragraph">
                These aren't just tips – they're your financial lifelines. Master these two habits, and you'll stay ahead of 80% of credit users in India.
            </p>

            <h3 className="rag-block-subheading">1. Make it a Monthly Ritual</h3>
            <p className="rag-block-paragraph">
                Set a calendar reminder to check your credit report every 30 days. Why? Because errors happen more often than you think – wrong addresses, accounts that aren't yours, or payments marked late when they weren't. Catching these early means fixing them fast, before they drag your score down for months.
            </p>
            <p className="rag-block-highlight"><strong>Pro move:</strong> Take a screenshot each month. Track your score changes and celebrate the wins – even a 10-point jump means you're moving in the right direction.</p>

            <h3 className="rag-block-subheading">2. Never Miss a Due Date – Ever</h3>
            <p className="rag-block-paragraph">
                This isn't negotiable. Payment history is 35% of your credit score, which means every single payment (or missed payment) matters. Even being 1 day late can hurt you.
            </p>
            <p className="rag-block-highlight"><strong>Make it automatic:</strong> Set up auto-pay for at least the minimum amount on all your credit cards and loans. Your future self will thank you when loan approvals start coming easier.</p>
            <p className="rag-block-highlight"><strong>The reality check:</strong> One missed payment can take 3–6 months of perfect payments to recover from. But here's the flip side – consistent on-time payments can boost your score by 50–100 points in just 3–4 months.</p>

            <p className="rag-block-conclusion">Small actions, massive results. Start today.</p>
        </div>
    </>)
}
const ReportAtGlance = ({ mainLoading, mainData, data }) => {
    const [isLoading, setIsLoading] = useState(false);
    const getMonthYearFromTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        const options = { month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-US', options); // e.g., "Mar 2024"
    }

    const getDetails = (type) => {
        const {
            newActiveAccounts = 0,
            newOnTimePaymentsPercentage = 0,
            oldActiveAccounts = 0,
            oldOnTimePaymentsPercentage = 0
        } = mainData?.whatsChanged || {}
        if (type === "type_payment") {
            return newOnTimePaymentsPercentage === oldOnTimePaymentsPercentage
                ? `remained same at ${oldOnTimePaymentsPercentage === 1 ? "100" : ((oldOnTimePaymentsPercentage) * 100).toFixed(1)}%` :
                `went from 
            ${(oldOnTimePaymentsPercentage * 100).toFixed(1)} 
            to 
            ${(newOnTimePaymentsPercentage * 100).toFixed(1)}
            `
        } else {
            return newActiveAccounts === oldActiveAccounts
                ? `remained same at ${oldActiveAccounts}` :
                `went from
            ${oldActiveAccounts}
            to
            ${newActiveAccounts}
            `
        }
        const res = "remained same at 100%" ?? "went from 2 to 3"
    }

    return (<>
        <div className="profile-info-page-main">
            <div className='profile-info-page-head'>
                <img crossOrigin="anonymous" src={userDetailIcon} alt='info icons' />
                <span>Profile Details</span>
            </div>
            <p className='rag-graph-head'>
                Credit Report at a glance
            </p>
            {
                !isLoading ?
                    <CreditScoreSteppedLineChart propData={data?.scoreTrendLine} mainLoading={isLoading} /> :
                    <div>Loading report data...</div>
            }
            <p className='rag-graph-head' style={{ marginTop: 40 }}>
                What’s changed in last month
            </p>
            <div className='rag-bar-block'>
                <div className='rag-bar-block-bar'>
                    <div className='rag-bar-block-bar-bar'>

                        <div>
                            <p className='rag-bar-score-hi'>{mainData?.whatsChanged?.oldScore}</p>
                            <div
                                className='rag-bar-block-bar-bar-1'
                                style={{ minHeight: 60, height: (.2 * (mainData?.whatsChanged?.oldScore - 300)) }}
                            >
                                {getMonthYearFromTimestamp(mainData?.whatsChanged?.oldReportDate) ?? 'N/A'}
                            </div>
                        </div>
                        <div>
                            <p className='rag-bar-score-hi'>{mainData?.whatsChanged?.newScore}</p>
                            <div
                                className='rag-bar-block-bar-bar-2'
                                style={{ minHeight: 60, height: (.2 * (mainData?.whatsChanged?.newScore - 300)) }}
                            >
                                {getMonthYearFromTimestamp(mainData?.whatsChanged?.newReportDate) ?? 'N/A'}
                            </div>
                        </div>
                    </div>
                    <div className='rag-bar-block-bar-info'>
                        <div className='rag-bar-block-bar-info-1'>
                            <img crossOrigin="anonymous" src={indexPageImg7} alt='info icons' />
                            <div>
                                <p>Payments made on-time</p>
                                <div>{getDetails("type_payment")}</div>
                            </div>
                        </div>
                        <div className='rag-bar-block-bar-info-2'>
                            <img crossOrigin="anonymous" src={indexPageImg8} alt='info icons' />
                            <div>
                                <p>Active credit accounts</p>
                                <div>{getDetails("type_active_accounts")}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className='rag-bar-block-tips'>
                <div className='rag-bar-block-tips-head'>
                    <div className='rag-bar-block-tips-head-1'>
                        <img crossOrigin="anonymous" src={indexPageImg6} alt='tips icons' />
                        <p>Tips</p>
                    </div>
                    <div className='rag-bar-block-tips-head-2'>
                        <p>Monitor your credit report frequently to catch errors or
                            suspicious activity early and maintain financial accuracy.
                        </p>
                        <p>
                            Timely payments positively impact your credit score and reflect
                            strong financial responsibility on your report.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

const GenericTopSection = ({ insightType, sectionType, data, isLoading }) => {
    const {
        main_color,
        first_line,
        first_img,
        head_main,
        head_para,
        indicator_block,
        two_stats,
    } = generic_stacked_record(insightType, sectionType, data)
    const getBrowserType = () => {
        const userAgent = navigator.userAgent;
        if (userAgent.includes("Chrome")) return "Chrome";
        if (userAgent.includes("Firefox")) return "Firefox";
        if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) return "Safari";
        if (userAgent.includes("Edge")) return "Edge";
        if (userAgent.includes("MSIE") || userAgent.includes("Trident")) return "Internet Explorer";
        return "Unknown";
    };


    return (<>
        <div className='generic-section-for-dr-top-text'>{first_line.text}</div>

        <div
            className='dcr-generic-top-payment'
            style={{
                backgroundColor: main_color.background,
                border: `.5px solid ${main_color.border_color}`,
                borderLeft: `6px solid ${indicator_block.border_color}`,
                height: getBrowserType() === "Safari" ? 80 : "",
            }}
        >
            <div className='dcr-generic-top-payment-impact-box'>
                <div className='dcr-generic-top-payment-impact'>
                    <div className='generic-impact-box-highlighter'
                        style={{
                            background: indicator_block.background,
                            border: `1px solid ${indicator_block.border_color}`,
                        }}
                    >
                        <img crossOrigin="anonymous" src={indicator_block.second_img.src} alt={indicator_block.second_img.alt} />
                        <span style={{ color: `${indicator_block.impact_text.text_color}` }}>{indicator_block.impact_text.text}</span>
                    </div>
                    <p style={{ color: `${head_main.text_color}` }}>{head_main.text}</p>
                </div>
                <div className='generic-impact-box-mid' style={{ padding: 10, background: "#f9f9f9ba", borderRadius: 10 }}>
                    {
                        two_stats.map((stat, index) =>
                            <><div key={index} >
                                <span style={{ color: `${stat.impact_value.text_color}`, fontSize: 14 }}>{stat.impact_value.text} </span>
                                <p style={{ color: `${stat.impact_text.text_color}`, fontSize: 12 }}>{stat.impact_text.text}</p>
                            </div>
                                {index === 0 ? <span className='generic-impact-box-mid-line'></span> : <></>}
                            </>
                        )

                    }
                </div>
            </div>
            <p
                style={{ color: `${head_para.text_color}` }}
            >
                {head_para.text}
            </p>
        </div>
        {/* <div className='generic-impact-box'

            style={{
                backgroundColor: main_color.background,
                border: `.5px solid ${main_color.border_color}`,
                borderLeft: `6px solid ${indicator_block.border_color}`,
                height: getBrowserType() === "Safari" ? 80 : "",
            }}
        >
            <div className='generic-impact-box-left-sts'>
                <div className='generic-impact-box-highlighter'
                    style={{
                        background: indicator_block.background,
                        border: `1px solid ${indicator_block.border_color}`,
                    }}
                >
                    <img crossOrigin="anonymous"    src={indicator_block.second_img.src} alt={indicator_block.second_img.alt} />
                    <span style={{ color: `${indicator_block.impact_text.text_color}` }}>{indicator_block.impact_text.text}</span>
                </div>
                <p style={{ color: `${head_main.text_color}` }}>{head_main.text}</p>
            </div>
            <div className='generic-impact-box-mid'>
                {
                    two_stats.map((stat, index) =>
                        <><div key={index} >
                            <span style={{ color: `${stat.impact_value.text_color}` }}>{stat.impact_value.text} </span>
                            <p style={{ color: `${stat.impact_text.text_color}` }}>{stat.impact_text.text}</p>
                        </div>
                            {index === 0 ? <span className='generic-impact-box-mid-line'></span> : <></>}
                        </>
                    )

                }
            </div>
            <div className='generic-impact-box-last' >
                <p
                    style={{ color: `${head_para.text_color}` }}
                >
                    {head_para.text}
                </p>
            </div>
        </div> */}
    </>)

}

const PaymentIndicationBlock = ({ insightType, mainData, isLoading }) => {
    const calculatePercentage = (a, b) => {
        if (b === 0) {
            return "100";
        }
        const percentage = (a / b) * 100
        return percentage.toFixed(0);
    }
    return (<>
        <div className='pib-main'>
            <GenericTopSection
                insightType={insightType}
                sectionType={"type_payment"}
                isLoading={isLoading}
                data={{
                    first_line: 100,
                    a: calculatePercentage(mainData?.latePayments, (mainData?.totalPayments === 0 ? 1 : mainData?.totalPayments)),
                    b: calculatePercentage(mainData?.onTimePayments === 0 ? 1 : mainData?.onTimePayments, (mainData?.totalPayments === 0 ? 1 : mainData?.totalPayments)),
                }}
            />
        </div>
    </>)
}
const CreditUtilisationIndicationBlock = ({ insightType, mainData, isLoading }) => {
    const calculatePercentage = (a, b) => {
        if (b === 0) {
            return "100";
        }
        const percentage = (a / b) * 100
        return percentage.toFixed(0);
    }
    return (<>
        <div className='pib-main'>
            <GenericTopSection
                insightType={insightType}
                sectionType="type_credit_utilisation"
                isLoading={isLoading}
                data={{
                    first_line: 100,
                    a: mainData?.limitUtilized.toLocaleString("en-IN"),
                    b: mainData?.creditLimit.toLocaleString("en-IN"),
                }}
            />
        </div>
    </>)
}
const CreditMixIndicationBlock = ({ insightType, mainData, isLoading }) => {
    const { activeAccounts,
        closedAccounts,
        activeLoanAccounts,
        activeSecureLoanAccounts,
        activeUnsecureLoanAccounts,
        activeCreditCards
    } = mainData || {};
    const calculatePercentage = (a, b) => {
        if (b === 0) {
            return "100";
        }
        const percentage = (a / b) * 100
        return percentage.toFixed(0);
    }
    return (<>
        <div className='pib-main'>
            <GenericTopSection
                insightType={insightType}
                sectionType={"type_accounts"}
                isLoading={isLoading}
                data={
                    {
                        first_line: 100,
                        noOfAccounts: activeAccounts || "0",
                        // type: accountType || "-",
                        a: activeAccounts || "0",
                        b: closedAccounts || "0",
                    }
                }
            />
        </div>
    </>)
}

const PaymentPage = ({ mainData, isLoading, insightType }) => {

    const checkSubType = (data) => {
        const { totalPayments, onTimePayments } = data || {};

        // Handle cases where mainData is empty or missing required fields
        if (!totalPayments || !onTimePayments) {
            return "type_poor";
        }
        const res = onTimePayments / totalPayments;

        if (res === 1) {
            return "type_perfect"
        } else if (res < 1 && res >= 0.9) {
            return "type_good"
        } else if (res < 0.9 && res >= 0.7) {
            return "type_fair"
        } else if (res < 0.7) {
            return "type_poor"
        }
    };
    useEffect(() => {

    }, [])

    const getColor = (it) => {
        switch (it) {
            case "Active":
                return "green";
            case "Closed":
                return "red";
            default:
                return "";
        }
    }

    const getValue = (it) => {
        if (it.length > 6) {
            return it.slice(0, 6);
        }
        switch (it) {
            case "Active":
                return "Active";
            case "Closed":
                return "Closed";
            default:
                return it;
        }
    }
    const shortenText = (text) => {
        if (text.length <= 10) return text; // If length is 10 or less, return as is
        const lastSix = text.slice(-4); // Get last 6 characters
        const hiddenPart = "x".repeat(6); // Replace the first part with 'X'
        return hiddenPart + lastSix;
    };

    const getColorFontPercentage = (account) => {
        const per = account.paymentPercentage * 100;
        const status = account.status;
        if (status === "Closed") {
            return { color: "#918b8b", fontWeight: "700" }
        } else {
            if (per >= 100) {
                return { color: "#75c258", fontWeight: "700" }
            } else if (per < 100 && per > 90) {
                return { color: "rgb(240, 194, 75)", fontWeight: "700" }
            } else if (per <= 90 && per > 70) {
                return { color: "#f9955b", fontWeight: "700" }
            } else if (per <= 70) {
                return { color: "#ff0000", fontWeight: "700" }
            }
        }
    }

    const getCreditPercentageColor = (account) => {
        const per = account.limitUtilized;
        if (per <= 30) {
            return "green"
        } else if (per > 30 && per < 70) {
            return "rgb(240, 194, 75)"
        } else if (per >= 70) {
            return "red"
        }
    }
    const getLabelColor = (label, account, value) => {
        if (label === "On-Time Payments") {
            return getColorFontPercentage(account).color;
        } else if (label === "Limit Used") {
            return getCreditPercentageColor(account);
        } else {
            return getColor(value);
        }
    };

    const reorderArray = (arr) => {
        return arr.sort((a, b) => {
            if (a.status === "Active") return -1; // Active should come first
            if (b.status === "Active") return 1;
            if (a.status === "Closed") return 1; // Closed should come last
            if (b.status === "Closed") return -1;
            return 0; // Keep others in between
        });
    };
    const createDetails = () => {
        const { mobile } = mainData || {};
        const formatText = (text) => {
            return text
                .toLowerCase() // Convert to lowercase
                .replace(/[_\.]+/g, " ") // Replace underscores and dots with spaces
                .split(" ") // Split into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter
                .join(" "); // Join words back into a sentence
        };
        let res = mainData?.insightAccountDetails
            .map((item) => ({
                data: item,
                mobileNumber: mobile,
                id: item.id,
                isAccountBad: item?.isAccountBad,
                bankName: item?.subscriberName || "-",
                loanType: formatText(item?.loanCategory) || "-",
                dateReported: item?.dateReported || "0",
                paymentPercentage: `${item?.onTimePayments / (item?.totalPayments)}`,
                accountType: checkSubType(item),
                status: formatText(item?.status),
                onTimePayments: `${item?.onTimePayments}/${item?.totalPayments} ` || "0/0",
                accountNo: item?.accountNumber || "-",
                details: {
                    delinquencyData: item?.delinquencyData || {}
                }
            }))
        let finalRes = reorderArray(res)
        return finalRes;
    }

    return (<>
        <div className="profile-info-page-main">
            <div className='profile-info-page-head'>
                <img crossOrigin="anonymous" style={{ height: 20 }} src={paymentIconNew} alt='info icons' />
                <span style={{ color: "#033B52" }}>
                    {/* Payments */}
                    Your Payment Journey - The Full Story
                </span>
            </div>
            {/* <p className='profile-info-page-head-para'>
                This section shows your payment history, including any delinquencies
                throughout your credit tenure, along with other essential details to
                help you track & manage your financial commitments effectively.
            </p> */}
            <div className='pdf-report-index-page-head-para'>
                {/* <h3 className='pdf-report-index-page-head-para-title' style={{ fontWeight: 600 }}>
                    Your Payment Journey – The Full Story
                </h3> */}

                <p className='pdf-report-index-page-head-para-text'>
                    Think of this as your financial report card, but better. Here's where we break down not just <i>what</i> happened with your payments, but <i>why</i> it matters and what you can do about it.
                </p>

                <p className='pdf-report-index-page-head-para-subtitle' style={{ margin: "20px 0px" }} ><b>What you'll see:</b></p>
                <ul className='pdf-report-index-page-head-para-ul'>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        Every payment you've made (or missed) across all your credit accounts.
                    </li>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        The exact dates when things went well – and when they didn't.
                    </li>
                </ul>

                <p className='pdf-report-index-page-head-para-subtitle' style={{ margin: "20px 0px" }} s><b>Why this matters:</b></p>
                <p className='pdf-report-index-page-head-para-text'>
                    Late payments don't just hurt today – they echo for months. Even one missed EMI can drop your score by 50–100 points and stay on your report for up to 3 years. But here's the good news: consistent on-time payments are the fastest way to rebuild trust with lenders.
                </p>

                <p className='pdf-report-index-page-head-para-subtitle' style={{ margin: "20px 0px" }}><b>Your next steps:</b></p>
                <ul className='pdf-report-index-page-head-para-ul' style={{ margin: "20px 0px" }}>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        ✓ <b>Spot the patterns</b> – Are you consistently late on specific types of loans? There might be a cash flow issue to address.
                    </li>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        ✓ <b>Set up auto-pay</b> – For at least the minimum amounts to avoid future slip-ups.
                    </li>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        ✓ <b>Focus on recency</b> – Recent good behavior weighs more than old mistakes.
                    </li>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        ✓ <b>Track your progress</b> – Watch how consistent payments start lifting your score within 2–3 months.
                    </li>
                </ul>

                <p className='pdf-report-index-page-head-para-text' style={{ margin: "35px 0px 45px" }}>
                    <b>Remember:</b> Your payment history makes up 35% of your credit score. Master this, and you're already one-third of the way to financial freedom.
                </p>
            </div>

            <PaymentIndicationBlock
                insightType={insightType}
                mainData={mainData}
                isLoading={isLoading}
            />
            <p className='profile-info-page-your-acc' style={{ paddingTop: 15 }}>Your Accounts ({mainData?.insightAccountDetails.length})</p>
            {
                createDetails().map((account, index) =>
                    <div
                        className='pipm-payment-item'
                        key={index}
                    >
                        {/* <h1>  {index + 1}</h1> */}
                        <div className='pipm-payment-item-top'>
                            <div className='pipm-payment-item-top-bank'>
                                <img crossOrigin="anonymous" src={BANK_IMG_STACK(account.bankName)} alt='bank-icon' />
                                <div>
                                    <p>{account.bankName}</p>
                                    <span>{account.loanType}</span>
                                </div>
                            </div>
                            <div className='pipm-payment-item-top-bank-status'>
                                <p>Status : </p>
                                <span
                                    style={{ color: getColor(account.status) }}
                                >{account.status}</span>
                            </div>
                        </div>
                        <div className='pipm-payment-item-bottom'>
                            <div>
                                <p>Account No : </p>
                                <span>{shortenText(account.accountNo)}</span>
                            </div>
                            <p></p>
                            <div>
                                <p>On-Time Payments</p>
                                <span>{account.onTimePayments}</span>
                            </div>
                        </div>

                    </div>
                )
            }
        </div>
    </>)

}

const CreditMixElementsPage = ({ mainData, isLoading, insightType, data, elementType }) => {
    const {
        totalSecuredAmount,
        totalUnsecuredAmount,
        totalCreditAmount,

        outstandingSecureAmount,
        outstandingUnsecureAmount,
        outstandingCreditAmount,

        secureAmountPastDue,
        unsecureAmountPastDue,
        creditAmountPastDue,

    } = data?.insightCreditMix?.ALL;
    const totalAmt = elementType === "Secured"
        ? totalSecuredAmount :
        (
            elementType === "Credit Card" ?
                totalCreditAmount :
                totalUnsecuredAmount
        );
    const totalOutStanding = elementType === "Secured"
        ? outstandingSecureAmount :
        (
            elementType === "Credit Card" ?
                outstandingCreditAmount :
                outstandingUnsecureAmount
        );
    const totalTotalAmountPassDue = elementType === "Secured"
        ? secureAmountPastDue :
        (
            elementType === "Credit Card" ?
                creditAmountPastDue :
                unsecureAmountPastDue
        );

    const getColor = (it) => {
        switch (it) {
            case "Active":
                return "green";
            case "Closed":
                return "red";
            default:
                return "";
        }
    }




    const reorderArray = (arr) => {
        return arr.sort((a, b) => {
            if (a.status === "Active") return -1; // Active should come first
            if (b.status === "Active") return 1;
            if (a.status === "Closed") return 1; // Closed should come last
            if (b.status === "Closed") return -1;
            return 0; // Keep others in between
        });
    };
    const createDetails = () => {
        const formatText = (text) => {
            return text
                .toLowerCase() // Convert to lowercase
                .replace(/[_\.]+/g, " ") // Replace underscores and dots with spaces
                .split(" ") // Split into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter
                .join(" "); // Join words back into a sentence
        };
        let resP = elementType === "UnSecured" ?
            "unsecureLoanAccountListDTOS" :
            (elementType === "Credit Card" ?
                "creditAccountListDTOS" :
                "secureLoanAccountListDTOS"
            )
        let res = data?.insightCreditMix?.ALL[resP]
            .map((item) => ({
                loanType: formatText(item?.loanCategory) || "-",
                bankName: elementType === "Credit Card" ? item.cardName : item.name,
                status: formatText(item?.status),
            }))
        let finalRes = reorderArray(res)
        return finalRes;
    }

    return (<>
        <div className="profile-info-page-main">
            <div className='payment-element-breadcrumb'>
                <div>
                    <img crossOrigin="anonymous" style={{ height: 30 }} src={creditMixIconNew} alt='icon' />
                    <span>Credit Mix Analysis</span>
                </div>
                <img crossOrigin="anonymous" src={rightArrowIcon} alt='icon' />
                <p>Accounts </p>
            </div>
            <div className='credit-mix-elements-block'>
                <p>{elementType}</p>
                <div className='credit-mix-elements-block-es'>
                    <div className='credit-mix-elements-block-e'>
                        <p>Total Amount</p>
                        <span>₹ {totalAmt.toLocaleString("en-IN") || "0"}</span>
                    </div>
                    <div className='credit-mix-elements-block-e'>
                        <p>Total outstanding</p>
                        <span>₹ {totalOutStanding.toLocaleString("en-IN") || "0"}</span>
                    </div>
                    <div className='credit-mix-elements-block-e'>
                        <p>Total Amount pass due</p>
                        <span>₹ {totalTotalAmountPassDue.toLocaleString("en-IN") || "0"}</span>
                    </div>
                </div>
            </div>

            <p className='profile-info-page-your-acc'>Your Accounts
                ({createDetails().length || 0})
            </p>
            {
                createDetails().map((account, index) =>
                    <div
                        className='pipm-payment-item'
                        key={index}
                    >
                        {/* <h1>  {index + 1}</h1> */}
                        <div className='pipm-payment-item-top'>
                            <div className='pipm-payment-item-top-bank'>
                                <img crossOrigin="anonymous" src={BANK_IMG_STACK(account.bankName)} alt='bank-icon' />
                                <div>
                                    <p>{account.bankName}</p>
                                    <span>{account.loanType}</span>
                                </div>
                            </div>
                            <div className='pipm-payment-item-top-bank-status'>
                                <p>Status : </p>
                                <span
                                    style={{ color: getColor(account.status) }}
                                >{account.status}</span>
                            </div>
                        </div>

                    </div>
                )
            }
        </div>
    </>)

}
const CheckLimitBar = ({ value }) => {
    const [animatedValue, setAnimatedValue] = useState(0);

    useEffect(() => {
        setTimeout(() => {
            if (value > 100) {
                setAnimatedValue(100);
            } else {
                setAnimatedValue(value);
            }

        }, 300);
    }, [value]);

    return (
        <div className="check-limit-block-bar">
            <div className="check-limit-block-bar-elm"

            >
                {/* Static mark at 30% */}
                <div className="static-marker" style={{ left: "30%" }}>
                    <span className="marker-text">30%</span>
                </div>

                {/* Dynamic pointer */}
                <div
                    className="check-limit-block-bar-elm-pointer"
                    style={{
                        left: `${value}%`,
                        border: `4px solid ${value < 30 ? "#53ba6e" : "red"}`
                    }}
                >
                    <div className="tooltip"
                        style={{
                            transform: `translateX(${value < 30 ? 0 : (-100)}%)`
                        }}

                    >{value > 100 ? ">100" : (typeof value === "number" && !isNaN(value) ? value.toFixed(1) : "0")}% Utilised</div>
                </div>
            </div>
        </div>
    );
};
const CreditUtilisationPage = ({ mainData, isLoading, insightType }) => {

    const checkSubType = (data) => {
        const { limitUtilized = 0, creditLimit = 1 } = data;
        const keyPer = (limitUtilized / creditLimit) * 100;
        if (keyPer < 30) return "type_perfect";
        if (keyPer < 70) return "type_high";
        return "type_extreme_high";
    };
    useEffect(() => {

    }, [])

    const getColor = (it) => {
        switch (it) {
            case "Active":
                return "green";
            case "Closed":
                return "red";
            default:
                return "";
        }
    }

    const getValue = (it) => {
        if (it.length > 6) {
            return it.slice(0, 6);
        }
        switch (it) {
            case "Active":
                return "Active";
            case "Closed":
                return "Closed";
            default:
                return it;
        }
    }
    const shortenText = (text) => {
        if (text.length <= 10) return text; // If length is 10 or less, return as is
        const lastSix = text.slice(-4); // Get last 6 characters
        const hiddenPart = "x".repeat(6); // Replace the first part with 'X'
        return hiddenPart + lastSix;
    };

    const getColorFontPercentage = (account) => {
        const per = account.paymentPercentage * 100;
        const status = account.status;
        if (status === "Closed") {
            return { color: "#918b8b", fontWeight: "700" }
        } else {
            if (per >= 100) {
                return { color: "#75c258", fontWeight: "700" }
            } else if (per < 100 && per > 90) {
                return { color: "rgb(240, 194, 75)", fontWeight: "700" }
            } else if (per <= 90 && per > 70) {
                return { color: "#f9955b", fontWeight: "700" }
            } else if (per <= 70) {
                return { color: "#ff0000", fontWeight: "700" }
            }
        }
    }

    const getCreditPercentageColor = (account) => {
        const per = account.limitUtilized;
        if (per <= 30) {
            return "green"
        } else if (per > 30 && per < 70) {
            return "rgb(240, 194, 75)"
        } else if (per >= 70) {
            return "red"
        }
    }
    const getLabelColor = (label, account, value) => {
        if (label === "On-Time Payments") {
            return getColorFontPercentage(account).color;
        } else if (label === "Limit Used") {
            return getCreditPercentageColor(account);
        } else {
            return getColor(value);
        }
    };

    const reorderArray = (arr) => {
        return arr.sort((a, b) => {
            if (a.status === "Active") return -1; // Active should come first
            if (b.status === "Active") return 1;
            if (a.status === "Closed") return 1; // Closed should come last
            if (b.status === "Closed") return -1;
            return 0; // Keep others in between
        });
    };
    const createDetails = () => {
        const { mobile } = mainData || {};
        const formatText = (text) => {
            return text
                .toLowerCase() // Convert to lowercase
                .replace(/[_\.]+/g, " ") // Replace underscores and dots with spaces
                .split(" ") // Split into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter
                .join(" "); // Join words back into a sentence
        };
        let res = mainData?.insightAccountDetails
            .filter((item) => item?.loanType === "CREDIT_CARD")
            .map((item) => ({
                data: item,
                mobileNumber: mobile,
                id: item.id,
                isAccountBad: item?.isAccountBad,
                bankName: item?.subscriberName || "-",
                loanType: formatText(item?.loanCategory) || "-",
                dateReported: item?.dateReported || "0",
                paymentPercentage: `${item?.onTimePayments / (item?.totalPayments)}`,
                accountType: checkSubType(item),
                status: formatText(item?.status),
                onTimePayments: `${item?.onTimePayments}/${item?.totalPayments} ` || "0/0",
                accountNo: item?.accountNumber || "-",
                limitUtilized: item?.limitUtilizedPercentage * 100 || "0",
                details: {
                    limitUtilized: item?.limitUtilized.toLocaleString("en-IN") || "0",
                    creditLimit: item?.creditLimit.toLocaleString("en-IN") || "0",
                }
            }))
        let finalRes = reorderArray(res)
        return finalRes;
    }
    const convertDateToFormat = (timestamp) => {
        const date = new Date(timestamp);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options);
    }

    const checkLimitBlock = (data) => {
        if (!data) return null;
        const { limitUtilized = 0, creditLimit = 0 } = data.details || {};
        return (
            <div className="check-limit-block" >
                <CheckLimitBar value={data?.limitUtilized} />
                <div className='check-limit-block-stats'>
                    <div>
                        <span>₹ {limitUtilized}</span>
                        <p>Limit Used</p>
                    </div>
                    <hr className='line-break-hr-2' />
                    <div>
                        <span>₹ {creditLimit}</span>
                        <p>Credit Limit</p>
                    </div>
                </div>
            </div>
        );
    };

    return (<>
        <div className="profile-info-page-main">
            <div className='profile-info-page-head'>
                <img crossOrigin="anonymous" src={creditUtilisationIconNew} alt='info icons' />
                <span style={{ color: "#033B52" }}>
                    {/* Credit Utilisation */}
                    Credit Utilisation Analysis
                </span>
            </div>
            {/* <p className='profile-info-page-head-para'>
                This section highlights your credit usage, showing how much of your available
                credit you have utilized. A high utilization rate may impact your
                credit score, while maintaining it below 30% is ideal for
                financial health. Tracking your credit usage helps manage debt
                responsibly and improves your creditworthiness.
            </p> */}
            <div className='pdf-report-index-page-head-para'>
                <h3 className='pdf-report-index-page-head-para-title' style={{ fontSize: 14, fontWeight: 600 }}>
                    Your Credit Utilisation – How Much Is Too Much?
                </h3>

                <p className='pdf-report-index-page-head-para-text'>
                    This shows how much of your available credit limit on your credit cards you're actually using. Think of it as your <i>“credit usage ratio”</i> – and it's one of the biggest factors affecting your credit score. Using too much of your available credit sends red flags to lenders, even if you pay on time.
                </p>

                <p className='pdf-report-index-page-head-para-subtitle'><b>Why This Matters:</b></p>
                <p className='pdf-report-index-page-head-para-text'>
                    Your credit utilisation makes up about 30% of your credit score calculation. High utilisation suggests you're financially stretched and rely heavily on credit to meet expenses. Lenders see this as risky behavior, even if you never miss payments.
                </p>

                <p className='pdf-report-index-page-head-para-subtitle'><b>The Golden Rules:</b></p>
                <ul className='pdf-report-index-page-head-para-ul'>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        <b>Keep it under 30%</b> – If your credit limit is ₹1 lakh, use maximum ₹30,000
                    </li>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        <b>Aim for under 10%</b> – For excellent scores, keep usage as low as possible
                    </li>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        <b>Per-card basis</b> – Don’t max out one card even if others are unused
                    </li>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        <b>Before statement date</b> – Your utilisation is calculated when your statement generates
                    </li>
                </ul>

                <p className='pdf-report-index-page-head-para-subtitle'><b>What You'll See Below:</b></p>
                <ul className='pdf-report-index-page-head-para-ul'>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        <b>Current utilisation percentage</b> across all cards
                    </li>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        <b>Individual card utilisation</b> breakdown
                    </li>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        <b>Month-on-month trends</b> in your credit usage
                    </li>
                    <li className='pdf-report-index-page-head-para-ul-li'>
                        <b>Recommendations</b> for optimal utilisation levels
                    </li>
                </ul>

                <p className='pdf-report-index-page-head-para-subtitle'><b>Quick Wins:</b></p>
                <p className='pdf-report-index-page-head-para-text'>
                    Pay down balances before your statement date, request credit limit increases, or spread purchases across multiple cards to keep individual utilisation low.
                </p>
            </div>
            {
                createDetails().length !== 0 ?
                    <>
                        <CreditUtilisationIndicationBlock
                            insightType={insightType}
                            mainData={mainData}
                            isLoading={isLoading}
                        />
                        <p className='profile-info-page-your-acc'>Your Accounts ({createDetails().length})</p>
                        {
                            createDetails().map((account, index) =>
                                <div style={{ border: "1px solid #e6e7e7", borderRadius: 10, margin: "10px 20px" }}>
                                    <div
                                        className='pipm-payment-item'
                                        key={index}
                                        style={{ border: 0, margin: 0 }}
                                    >
                                        {/* <h1>  {index + 1}</h1> */}
                                        <div className='pipm-payment-item-top'>
                                            <div className='pipm-payment-item-top-bank'>
                                                <img crossOrigin="anonymous" src={BANK_IMG_STACK(account.bankName)} alt='bank-icon' />
                                                <div>
                                                    <p>{account.bankName}</p>
                                                    <span>{account.loanType}</span>
                                                </div>
                                            </div>
                                            <div className='pipm-payment-item-top-bank-status'>
                                                <p>Status : </p>
                                                <span
                                                    style={{ color: getColor(account.status) }}
                                                >{account.status}</span>
                                            </div>
                                        </div>
                                        <div className='pipm-payment-item-bottom'>
                                            <div>
                                                <p>Account No : </p>
                                                <span>{shortenText(account.accountNo)}</span>
                                            </div>
                                            <p></p>
                                            <div>
                                                <p>On-Time Payments</p>
                                                <span>{account.onTimePayments}</span>
                                            </div>
                                        </div>


                                    </div>
                                    <div style={{ height: 1, background: "#EAECF0", margin: "10px 20px" }}></div>
                                    <div className='cub-inner-part'>
                                        <p>Credit utlization</p>
                                        <span>Last Update on {convertDateToFormat(account?.dateReported)} as reported by Experian Bureau. Stay under 30% credit use for good credit</span>
                                    </div>
                                    {
                                        account.status === "Active" ?
                                            checkLimitBlock(account) :
                                            null
                                    }

                                </div>
                            )
                        }
                    </> :
                    null
            }

        </div>
    </>)

}
function convertObjectToArray(obj) {
    // Optional: Make keys more human-readable
    function formatKey(key) {
        return key
            .replace(/([A-Z])/g, " $1")         // insert space before capital letters
            .replace(/^./, str => str.toUpperCase()); // capitalize first letter
    }
    return Object.entries(obj).map(([key, value]) => {
        let displayValue;

        if (value === null || value === undefined) {
            displayValue = "NA";
        } else if (typeof value === "boolean") {
            displayValue = value ? "Yes" : "No";
        } else {
            displayValue = value;
        }

        return {
            label: formatKey(key),
            value: displayValue
        };
    });
}



const PaymentElementsPage = ({ account, accountIndex }) => {
    const getColorFontPercentage = (account) => {
        let paymentPercentage = account?.onTimePayments / (account?.totalPayments)
        const per = paymentPercentage * 100;
        const status = account.status;
        if (status === "Closed") {
            return { color: "#918b8b", fontWeight: "700" }
        } else {
            if (per >= 100) {
                return { color: "#75c258", fontWeight: "700" }
            } else if (per < 100 && per > 90) {
                return { color: "rgb(240, 194, 75)", fontWeight: "700" }
            } else if (per <= 90 && per > 70) {
                return { color: "#f9955b", fontWeight: "700" }
            } else if (per <= 70) {
                return { color: "#ff0000", fontWeight: "700" }
            }
        }
    }
    const formatText = (text) => {
        return text
            .toLowerCase() // Convert to lowercase
            .replace(/[_\.]+/g, " ") // Replace underscores and dots with spaces
            .split(" ") // Split into words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter
            .join(" "); // Join words back into a sentence
    };
    const convertDateToFormat = (timestamp) => {
        const date = new Date(timestamp);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options);
    }
    const shortenText = (text) => {
        if (text.length <= 10) return text; // If length is 10 or less, return as is
        const lastSix = text.slice(-4); // Get last 6 characters
        const hiddenPart = "x".repeat(6); // Replace the first part with 'X'
        return hiddenPart + lastSix;
    };
    const convertMonthsToYears = (months) => {
        const years = Math.floor(months / 12);
        const remainingMonths = months % 12;
        return `${years}Y ${remainingMonths > 0 ? `& ${remainingMonths}M` : ""}`;
    };
    const dataArray = [
        { label: "Account Number", value: shortenText(account.accountNumber) || "NA" },
        { label: "Age", value: convertMonthsToYears(account?.age) ?? "NA" },
        { label: "Amount Past Due", value: account.amountPastDue ?? "NA" },
        { label: "Credit Limit", value: (account.creditLimit ?? "NA").toLocaleString() },
        { label: "Date Reported", value: convertDateToFormat(account.dateReported) ?? "NA" },
        { label: "Open Date", value: convertDateToFormat(account.openDate) ?? "NA" },
        { label: "Days Past Due", value: account.daysPastDue ?? "NA" },
        // { label: "Identification Number", value: account.identificationNumber || "NA" },
        { label: "Is Account Bad", value: account.isAccountBad !== undefined ? (account.isAccountBad ? "Yes" : "No") : "NA" },
        { label: "Limit Utilized", value: (account.limitUtilized ?? "NA").toLocaleString() },
        { label: "Limit Utilized %", value: (account.limitUtilizedPercentage * 100).toFixed(2) ?? "NA" },
        { label: "Loan Category", value: account.loanCategory || "NA" },
        { label: "Loan Type", value: account.loanType || "NA" },
        { label: "Total Payments", value: account.totalPayments ?? "NA" },
        { label: "On-Time Payments", value: account.onTimePayments ?? "NA" },
        { label: "Outstanding Loan Amount", value: (account.outstandingLoanAmount ?? "NA").toLocaleString() },
        { label: "Rate Of Interest", value: account.rateOfInterest ?? "NA" },
        { label: "Status", value: account.status || "NA" },
        { label: "Tenure (months)", value: convertMonthsToYears(account.tenure) ?? "NA" },
        { label: "Total Loan Amount", value: (account.totalLoanAmount ?? "NA").toLocaleString() },

    ];

    const Delinquency = () => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        // Reverse years to show the latest year first
        const years = Object.keys(account?.delinquencyData ?? [])
            .map(Number) // Convert string keys to numbers
            .sort((a, b) => b - a); // Sort in descending order (latest year first)

        const [currentYearIndex, setCurrentYearIndex] = useState(0);
        const convertDelinquencyData = (data) => {
            const delinquencyData = {};
            const threshold = 90; // Values 3 and above are marked as "late"
            const currentYear = new Date().getFullYear();
            const currentMonth = new Date().getMonth();

            Object.keys(data).forEach((year) => {
                const yearData = data[year];

                delinquencyData[year] = months.map((month, index) => {
                    let value = 'blank';
                    if (yearData && index < yearData.length) {
                        const status = yearData[index];
                        if (status === 0) {
                            value = 'on-time';
                        } else if (status === -1) {
                            value = 'blank';
                        } else if (status >= 1 && status < threshold) {
                            value = 'amber';
                        } else if (status >= threshold) {
                            value = 'late';
                        }
                    }

                    // Limit current year data to months up to the current month
                    if (parseInt(year) === currentYear && index > currentMonth) {
                        value = 'blank';
                    }

                    return { month, value };
                });
            });

            return delinquencyData;
        };

        const delinquencyDataMobile = convertObjectToArray(convertDelinquencyData(account?.delinquencyData ?? {}));

        const check_Type = (type) => {
            switch (type) {
                case 'on-time':
                    return paymentMark1;
                case 'amber':
                    return paymentMark2;
                case 'late':
                    return paymentMark3;
                case 'blank':
                    return paymentMark4;
                default:
                    return;
            }
        };


        return (
            <>
                {delinquencyDataMobile.map((mainItem, i) =>
                    <>
                        <p className='pds-label' >{mainItem.label}</p>
                        <div className='payment-del-sub-content-blocks-pds'>
                            {mainItem.value.map((item, index) =>
                                <div key={index + "payment-del-content"} className='payment-del-sub-content-block-pds'>
                                    <p>{item?.month}</p>
                                    <img crossOrigin="anonymous" src={check_Type(item?.value)} alt={item?.label} />
                                </div>
                            )}
                        </div>
                    </>
                )
                }

            </>
        );
    };
    const check_Verbiage = (acct_type = "type_fair") => {

        const checkTypeForThis = (typ) => {
            switch (typ) {
                case "type_perfect":
                    return {
                        background: "#ebf9f3",
                        src: paymentMark1,
                        alt: "Perfect",
                        label: "Perfect !",
                        para: "You’ve successfully maintained on-time payments for the past three months. Keep it up!"
                    }
                case "type_good":
                    return {
                        background: "#ebf9f3",
                        src: paymentMark2,
                        alt: "Good",
                        label: "Good !",
                        para: "For this account, you’ve been timely with most payments. To enhance your credit standing, it’s important to make sure that you do not miss any future payments and maintain a perfect payment history. This account is impacting your credit score negatively. "
                    }
                case "type_fair":
                    return {
                        background: "#FEF0C7",
                        src: paymentMark3,
                        alt: "Fair",
                        label: "Fair !",
                        para: "For this account, there have been occasional missed payments. Fund your account much ahead of due date, set reminders or automate payments to improve on time payment record. This account is impacting your credit score negatively. "
                    }
                case "type_poor":
                    return {
                        background: "#FFE9E7",
                        src: paymentMark4,
                        alt: "Poor",
                        label: "Poor !",
                        para: "For this account, several payments have been missed, placing the account in a high-risk category and worsening your overall credit standing."
                    }
                default:
                    return {}
            }
        }
        const {
            background,
            src,
            alt,
            label,
            para
        } = checkTypeForThis(acct_type);
        return (<>
            <div className='payment-acct-verbiage-pcv'
                style={{ background: background, borderRadius: 15 }}
            >
                <img src={src} alt={alt} />
                {acct_type === "type_perfect" ? <b>{label}</b> : null}
                <p>{para}</p>
            </div>
        </>)
    }
    const checkSubType = () => {
        const { totalPayments, onTimePayments } = account || {};

        // Handle cases where mainData is empty or missing required fields
        if (!totalPayments || !onTimePayments) {
            return "type_poor";
        }
        const res = onTimePayments / totalPayments;

        if (res === 1) {
            return "type_perfect"
        } else if (res < 1 && res >= 0.9) {
            return "type_good"
        } else if (res < 0.9 && res >= 0.7) {
            return "type_fair"
        } else if (res < 0.7) {
            return "type_poor"
        }
    };
    const getColor = (it) => {
        switch (it) {
            case "Active":
                return "green";
            case "Closed":
                return "red";
            default:
                return "";
        }
    }
    return (<>
        <div className="profile-info-page-main">
            <div className='payment-element-breadcrumb'>
                <div>
                    <img crossOrigin="anonymous" style={{ height: 20 }} src={paymentIconNew} alt='icon' />
                    <span>Payments</span>
                </div>
                <img crossOrigin="anonymous" src={rightArrowIcon} alt='icon' />
                <p>Account Details ({accountIndex})</p>
            </div>
            <div
                className='pipm-payment-item'
                style={{ border: 0 }}
            >
                <div className='pipm-payment-item-top'>
                    <div className='pipm-payment-item-top-bank'>
                        <img crossOrigin="anonymous" src={BANK_IMG_STACK(account?.subscriberName)} alt='bank-icon' />
                        <div>
                            <p>{account.subscriberName}</p>
                            <span>{formatText(account?.loanCategory) || "-"}</span>
                        </div>
                    </div>
                    <div className='pipm-payment-item-top-bank-status'>
                        <p>Status : </p>
                        <span
                            style={{ color: getColor(formatText(account?.status)) }}
                        >{formatText(account?.status)}</span>
                    </div>
                </div>
                <div className='pipm-payment-item-bottom'>
                    <div>
                        <p>Account No : </p>
                        <span>{account?.accountNumber || "-"}</span>
                    </div>
                    <p></p>
                    <div>
                        <p>On-Time Payments</p>
                        <span>{`${account?.onTimePayments}/${account?.totalPayments} ` || "0/0"}</span>
                    </div>
                </div>

            </div>
            <div className='payment-element-detail-head'>
                <p>Account Details</p>
                <span>Last Update on {convertDateToFormat(account?.dateReported)} as reported by Experian Bureau</span>
            </div>

            <div className="grid-container-pedh">
                {dataArray.map((item, index) => (
                    <div className="grid-item-pedh" key={index}>
                        <span className="label-pedh">{item.label}</span> : <span className="value-pedh">{item.value}</span>
                    </div>
                ))}
            </div>

            <div className='payment-element-detail-head' style={{ marginTop: 20 }}>
                <p>Payment History for this account</p>
                <div className='pedh-payment-marks'>
                    <div>
                        <img crossOrigin="anonymous" src={paymentMark1} alt='icon' />
                        <p>Paid On Time</p>
                    </div>
                    <div>
                        <img crossOrigin="anonymous" src={paymentMark2} alt='icon' />
                        <p>1-89 Days late</p>
                    </div>
                    <div>
                        <img crossOrigin="anonymous" src={paymentMark3} alt='icon' />
                        <p>90+ Days late</p>
                    </div>
                    <div>
                        <img crossOrigin="anonymous" src={paymentMark4} alt='icon' />
                        <p>Not Available</p>
                    </div>
                </div>
            </div>

            {Delinquency()}
            {account?.status === "Closed" ? null : check_Verbiage(checkSubType())}

            <div className='pcv-settle-writeo'>
                <div>
                    <p>Settled Amount</p>
                    <span>N/A</span>
                </div>
                <div>
                    <p>Principal Write-off amount</p>
                    <span>N/A</span>
                </div>
                <div>
                    <p>Total Write-off amount</p>
                    <span>N/A</span>
                </div>
            </div>
        </div>
    </>)
}


const CreditMixPage = ({ mainData, isLoading, insightType, data }) => {
    const { insightCreditMix } = data || {};
    const {
        totalAccounts = 0,
        securedAccounts = 0,
        unsecuredAccounts = 0,
        creditCardAccounts = 0,

        amountAddedLastThreeMonths = 0,
        outstandingAmountAddedLastThreeMonths = 0,
        totalAmount = 0,
        totalOutstandingAmount = 0

    } = insightCreditMix?.ALL || {};



    const getDataList = () => {
        return [
            { label: "Secured", value: ((securedAccounts / totalAccounts) * 100).toFixed(2) + "%", color: "#5DA3C0" },
            { label: "Unsecured ", value: ((unsecuredAccounts / totalAccounts) * 100).toFixed(2) + "%", color: "#98DEFB" },
            { label: "Credit Card", value: ((creditCardAccounts / totalAccounts) * 100).toFixed(2) + "%", color: "#044A67" },
        ];
    }

    console.log(getDataList());

    const dataVar = [
        ["Category", "Value"],
        ["Secured", (securedAccounts / totalAccounts)],
        ["Unsecured", (unsecuredAccounts / totalAccounts)],
        ["Credit Card", (creditCardAccounts / totalAccounts)],
    ];
    const dataVar2 = [
        ["Category", "Value"],
        ["last 3 months", amountAddedLastThreeMonths],
        ["total", totalAmount],
    ];
    const dataVar3 = [
        ["Category", "Value"],
        ["last 3 months", outstandingAmountAddedLastThreeMonths],
        ["total", totalOutstandingAmount],
    ];

    const options = {
        pieHole: 0.5,
        legend: "none",
        pieSliceText: "none",
        chartArea: { width: "90%", height: "90%" },
        title: "Top 3 Daily Activities",
        colors: ["#5DA3C0", "#98DEFB", "#044A67"], // red, purple, yellow
        backgroundColor: "#ebf2fd",
    };
    const options2 = {
        pieHole: 0.82,
        legend: "none",
        pieSliceText: "none",
        chartArea: { width: "90%", height: "90%" },
        title: "Top 3 Daily Activities",
        colors: ["#17B26A", "#C3D3EF"], // red, purple, yellow
        backgroundColor: "#ebf2fd",
    };
    return (<>
        <div className="profile-info-page-main">
            <div className='profile-info-page-head'>
                <img crossOrigin="anonymous" style={{ height: 30 }} src={creditMixIconNew} alt='info icons' />
                <span style={{ color: "#033B52" }}>Credit Mix Analysis</span>
            </div>
            {/* <p className='profile-info-page-head-para'>
                This section highlights your credit usage, showing how much of
                your available credit you have utilized. A high utilization rate
                may impact your credit score, while maintaining it below 30% is
                ideal for financial health. Tracking your credit usage helps
                manage debt responsibly and improves your creditworthiness.
            </p> */}
            <div className='pdf-report-index-page-head-para'>
                <h3 className='pdf-report-index-page-head-para-title' style={{ fontSize: 14, fontWeight: 600 }}>
                    Your Credit Mix – Why Variety Matters
                </h3>

                <p className='pdf-report-index-page-head-para-text'>
                    Your credit mix shows the variety of credit accounts in your portfolio – from credit cards and personal loans to home loans and secured credit. A well-balanced mix demonstrates to lenders that you can responsibly handle different types of credit, which can boost your credit score.
                </p>

                <p className='pdf-report-index-page-head-para-subtitle' style={{ margin: "20px 0px" }}><b>Why This Matters:</b></p>
                <p className='pdf-report-index-page-head-para-text'>
                    Lenders want to see that you're not just good with one type of credit. When you successfully manage both revolving credit (like credit cards) and installment loans (like personal or home loans), it shows financial maturity and reduces lending risk.
                </p>

                <p className='pdf-report-index-page-head-para-subtitle' style={{ margin: "20px 0px" }}><b>What Makes a Good Credit Mix:</b></p>
                <ul className='pdf-report-index-page-head-para-ul'>
                    <li className='pdf-report-index-page-head-para-ul-li'><b>Secured Credit</b> – Home loans, car loans, gold loans</li>
                    <li className='pdf-report-index-page-head-para-ul-li'><b>Unsecured Credit</b> – Personal loans, credit cards</li>
                    <li className='pdf-report-index-page-head-para-ul-li'><b>Revolving Credit</b> – Credit cards, overdraft facilities</li>
                    <li className='pdf-report-index-page-head-para-ul-li'><b>Fixed Installments</b> – EMIs for loans</li>
                </ul>

                <p className='pdf-report-index-page-head-para-subtitle' style={{ margin: "20px 0px" }}><b>Your Next Step:</b></p>
                <p className='pdf-report-index-page-head-para-text'>
                    Review your current credit mix below. If you only have credit cards, consider a small personal loan. If you only have loans, a responsibly-used credit card can help. Remember – only take credit you actually need and can repay comfortably.
                </p>
            </div>

            <CreditMixIndicationBlock
                insightType={insightType}
                mainData={mainData}
                isLoading={isLoading}
            />


            <div className='credit-mix-graphs'>
                <div className='credit-mix-graphs-a' >
                    <div className='credit-mix-graphs-a-1'>
                        {/* <DonutChart /> */}
                        <Chart
                            chartType="PieChart"
                            data={dataVar}
                            options={options}
                            width={"100%"}
                            height={"100%"}
                        />
                    </div>
                    <div className='credit-mix-graphs-a-2'>
                        {
                            getDataList().map((item) =>
                                <div>
                                    <div style={{ background: item.color }}></div>
                                    <p>{item.label} ({item.value})</p>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className='credit-mix-graphs-b'>
                    <div className='credit-mix-graphs-b-a'>
                        <p>Total Amount</p>
                        <div className='credit-mix-graphs-b-a-block'>
                            <div className='credit-mix-graphs-b-a-block-a'>
                                <div className='credit-mix-graphs-b-a-block-a-1'>
                                    {/* <DonutChart2 a={10} b={30} /> */}

                                    {
                                        totalAmount === 0 ?
                                            "N/A" :
                                            <Chart
                                                chartType="PieChart"
                                                data={dataVar2}
                                                options={options2}
                                                width={"100%"}
                                                height={"100%"}
                                            />
                                    }
                                </div>
                                <div className='credit-mix-graphs-b-a-block-a-2'>
                                    <p>₹{amountAddedLastThreeMonths.toLocaleString("en-IN")}</p>
                                    <span> Latest Amount Added</span>
                                </div>
                            </div>
                            <div className='credit-mix-graphs-b-a-block-b'>
                                <p>Total amount till date</p>
                                <span> ₹{totalAmount.toLocaleString("en-IN")}</span>
                            </div>
                        </div>
                    </div>
                    <div className='credit-mix-graphs-b-a'>
                        <p>Total Outstanding Amount</p>
                        <div className='credit-mix-graphs-b-a-block'>
                            <div className='credit-mix-graphs-b-a-block-a'>
                                <div className='credit-mix-graphs-b-a-block-a-1'>
                                    {/* <DonutChart2 a={10} b={30} /> */}

                                    {
                                        totalOutstandingAmount === 0 ?
                                            "N/A" :
                                            <Chart
                                                chartType="PieChart"
                                                data={dataVar3}
                                                options={options2}
                                                width={"100%"}
                                                height={"100%"}
                                            />
                                    }
                                </div>
                                <div className='credit-mix-graphs-b-a-block-a-2'>
                                    <p>₹{outstandingAmountAddedLastThreeMonths.toLocaleString("en-IN")}</p>
                                    <span> Latest Amount Added</span>
                                </div>
                            </div>
                            <div className='credit-mix-graphs-b-a-block-b'>
                                <p>Total amount till date</p>
                                <span> ₹{totalOutstandingAmount.toLocaleString("en-IN")}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)

}

const EnquiryPage = ({ mainData, isLoading, insightType, data }) => {
    const { bureauInquiries = [] } = mainData;
    return (<>
        <div className="profile-info-page-main">
            <div className='profile-info-page-head'>
                <img crossOrigin="anonymous" style={{ height: 25 }} src={enquiryIcon} alt='info icons' />
                <span style={{ color: "#033B52" }}>
                    Credit Enquiries</span>
            </div>
            {/* <p className='profile-info-page-head-para'>
                This section provides a summary of your credit enquiries made by financial
                institutions in response to applications for credit cards, personal loans,
                home loans, or other credit products. Frequent or recent enquiries can
                signal higher credit-seeking activity, which may impact your credit
                score. Monitoring your credit enquiries helps you stay informed about
                who is accessing your credit report and ensures you're aware of
                potential impacts on your creditworthiness.
            </p> */}
            <div className='pdf-report-index-page-head-para'>
                <h3 className='pdf-report-index-page-head-para-title'>
                    Credit Enquiries – Handle With Care
                </h3>

                <p className='pdf-report-index-page-head-para-text'>
                    Every time you apply for a credit card, loan, or any credit product, lenders check your credit report – this creates a "hard enquiry." While one or two enquiries are normal, multiple enquiries in a short period can hurt your credit score and signal credit hunger to future lenders.
                </p>

                <p className='pdf-report-index-page-head-para-subtitle' style={{ margin: "20px 0px" }}><b>Why This Matters:</b></p>
                <p className='pdf-report-index-page-head-para-text'>
                    Too many enquiries suggest you're desperately seeking credit, which makes lenders nervous. Each hard enquiry can temporarily lower your score by 5–10 points, and the impact stays on your report for 2 years.
                </p>

                <p className='pdf-report-index-page-head-para-subtitle' style={{ margin: "20px 0px" }}><b>What You'll See Below:</b></p>
                <ul className='pdf-report-index-page-head-para-ul'>
                    <li className='pdf-report-index-page-head-para-ul-li'><b>Recent Enquiries</b> – Applications made in the last 90 days</li>
                    <li className='pdf-report-index-page-head-para-ul-li'><b>Enquiry Source</b> – Which bank or NBFC checked your report</li>
                    <li className='pdf-report-index-page-head-para-ul-li'><b>Purpose</b> – Whether it was for a credit card, personal loan, or other product</li>
                </ul>

                <p className='pdf-report-index-page-head-para-subtitle' style={{ margin: "20px 0px" }}><b>Your Action Plan:</b></p>
                <p className='pdf-report-index-page-head-para-text'>
                    Space out your credit applications to 1 or 2 enquiries in a 90-day period. If you see any enquiries you didn't authorize, report them immediately – this could be a sign of fraud. Before applying for new credit, ensure you meet the eligibility criteria to avoid unnecessary rejections and enquiries.
                </p>

                <p className='pdf-report-index-page-head-para-text'>
                    <b>Pro Tip:</b> Checking your own credit score doesn't count as a hard enquiry and won't hurt your score.
                </p>
            </div>

            {bureauInquiries.length < 1 ?
                <p
                    style={{ margin: 20, fontSize: 14, fontWeight: 400, lineHeight: 1.6, color: "#033B52" }}
                >No latest enquires available</p>
                :
                <div className='enquiry-table-d-s'>
                    <div className='enquiry-table-d-s-head'>
                        <p>Category</p>
                        <p>Financial Institute</p>
                        <p>Enquired on</p>
                    </div>

                    {bureauInquiries.map((item, i) =>
                        <div className='enquiry-table-d-s-items'>
                            <p>{item.loanCategory} </p>
                            <p>{item.enquiryReason} </p>
                            <p>{item.inquiryDate} </p>
                        </div>
                    )}

                </div>
            }
            <div className='enquiry-tips-d'>
                <div>Tip's</div>
                <p>
                    Limit frequent credit applications, as each enquiry can slightly
                    lower your credit score. Only apply when necessary, and
                    monitor your report regularly for unauthorized checks.
                    Multiple enquiries in a short time may indicate risk to
                    lenders. Maintain good credit habits to offset enquiry
                    impact and boost overall creditworthiness.
                </p>
            </div>


        </div>
    </>)

}

const ReportAnErrorPage = ({ mainData, isLoading, insightType, data }) => {
    const { bureauInquiries = [] } = mainData;
    return (<>
        <div className="profile-info-page-main">
            <div className='profile-info-page-head'>
                <img crossOrigin="anonymous" src={ReportAnErrorIcon} alt='info icons' />
                <span style={{ color: "#033B52" }}>Report an Error</span>
            </div>
            <p className='profile-info-page-head-para'>
                This section guides you on reporting errors in your credit report
                to Experian. If you find incorrect information, promptly raise a
                dispute with supporting documents. Accurate credit data ensures fair
                credit scores. Resolving discrepancies helps maintain your financial
                reputation and ensures lenders view your credit profile correctly and
                fairly.
            </p>

            <div className='report-an-error-exp'>
                <p> Raise a dispute to </p>
                <img src={exp_img} alt='exper-img' />
            </div>


            <div className='report-an-error-points'>
                <p>
                    <b>Identify the Errors </b>
                    – Review the report carefully and note incorrect information like inaccurate
                    accounts, payment history, or personal details
                </p>
                <p>
                    <b>Submit a Dispute </b>
                    – Visit Experian’s dispute portal or send a written request with
                    supporting documents to verify your claim.
                </p>
                <p>
                    <b>Wait for Investigation </b>
                    – Experian will investigate the dispute by contacting the
                    lender or data provider, typically resolving within 30 days.
                </p>
                <p>
                    <b>Review the Updates </b>
                    – Check your updated credit report to ensure corrections have been
                    made. If unresolved, escalate the issue with additional proof
                </p>
            </div>


        </div>
    </>)

}

const DownloadCreditReport = forwardRef((props, ref) => {
    const [isLoading, setIsLoading] = useState(false);
    const [insightType, setInsightType] = useState("");
    const [insightTypeCU, setInsightTypeCU] = useState("");
    const [insightTypeCM, setInsightTypeCM] = useState("");
    const [data, setData] = useState({});
    const [profileData, setProfileData] = useState({});
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [mainData, setMainData] = useState({
        insightAccountDetails: []
    })

    const reportRef = useRef(null);
    const currentBodyRef = useRef(null);

    // const handleDownload = () => {
    //     if (reportRef.current) {
    //         html2pdf()
    //             .set({
    //                 margin: [0, 0, 0, 0], // Top, Right, Bottom, Left margins
    //                 filename: "Credit-Report.pdf",
    //                 image: { type: "jpeg", quality: 1 },
    //                 html2canvas: { scale: 2, useCORS: true },
    //                 jsPDF: { format: "a4", orientation: "portrait" }
    //             })
    //             .from(reportRef.current)
    //             .save("Credit-Report.pdf");
    //     }
    // };

    // const handleDownload = async () => {
    //     const reportEl = reportRef.current;
    //     if (!reportEl) return;

    //     const pageEls = reportEl.querySelectorAll('.pdf-page'); // each should be 794x1120px
    //     const pdf = new jsPDF({
    //         unit: "px",
    //         format: [794, 1120],
    //         orientation: "portrait"
    //     });

    //     // Helper: Wait for images inside a given element to fully load
    //     const waitForImages = async (element) => {
    //         const images = element.querySelectorAll("img");
    //         await Promise.all(
    //             Array.from(images).map((img) => {
    //                 if (!img.complete) {
    //                     return new Promise((resolve) => {
    //                         img.onload = img.onerror = resolve;
    //                     });
    //                 }
    //                 return Promise.resolve();
    //             })
    //         );
    //     };

    //     for (let i = 0; i < pageEls.length; i++) {
    //         const page = pageEls[i];

    //         await waitForImages(page);

    //         const canvas = await html2canvas(page, {
    //             scale: 2,
    //             useCORS: true,
    //         });

    //         const imgData = canvas.toDataURL("image/jpeg", 1.0);
    //         if (i > 0) pdf.addPage();
    //         pdf.addImage(imgData, "JPEG", 0, 0, 794, 1123);

    //         // Optional: log progress
    //         console.log(`Rendered page ${i + 1} of ${pageEls.length}`);
    //     }

    //     pdf.save("Credit-Report.pdf");
    // };

    // const handleDownload = async () => {
    //     const reportEl2 = reportRef.current;
    //     if (!reportEl2) return;

    //     // Deep clone the element
    //     const reportEl = reportEl2.cloneNode(true);

    //     // Clean styles: remove visibility and position from .pdf-page elements
    //     const pageEls = reportEl.querySelectorAll(".pdf-page");
    //     pageEls.forEach((el) => {
    //         const originalStyle = el.getAttribute("style") || "";
    //         const cleanedStyle = originalStyle
    //             .replace(/visibility\s*:\s*hidden\s*;?/gi, '')
    //             .replace(/position\s*:\s*absolute\s*;?/gi, '')
    //             .trim();
    //         el.setAttribute("style", cleanedStyle);
    //     });

    //     // Hide and append to body
    //     reportEl.style.position = 'absolute';
    //     reportEl.style.left = '-9999px';
    //     reportEl.style.top = '0';
    //     document.body.appendChild(reportEl);

    //     // Setup PDF
    //     const pdf = new jsPDF({
    //         unit: "px",
    //         format: [794, 1120],
    //         orientation: "portrait"
    //     });

    //     // Preload all images once
    //     const preloadImages = async () => {
    //         const images = reportEl.querySelectorAll("img");
    //         await Promise.all(
    //             Array.from(images).map((img) => {
    //                 if (!img.complete) {
    //                     return new Promise((resolve) => {
    //                         img.onload = img.onerror = resolve;
    //                     });
    //                 }
    //                 return Promise.resolve();
    //             })
    //         );
    //     };

    //     await preloadImages();

    //     const SCALE = 2; // Lower scale for speed + smaller size

    //     for (let i = 0; i < pageEls.length; i++) {
    //         const canvas = await html2canvas(pageEls[i], {
    //             scale: SCALE,
    //             useCORS: true,
    //             backgroundColor: "#fff",
    //             logging: false
    //         });

    //         const imgData = canvas.toDataURL("image/jpeg", 0.9); // Lower quality = smaller file
    //         if (i > 0) pdf.addPage();
    //         pdf.addImage(imgData, "JPEG", 0, 0, 794, 1120);

    //         console.log(`Rendered page ${i + 1} of ${pageEls.length}`);
    //     }

    //     // Clean up cloned element
    //     document.body.removeChild(reportEl);

    //     // Save the PDF
    //     pdf.save("Credit-Report.pdf");
    // };

    const handleDownload = async () => {
        const reportEl2 = reportRef.current;
        if (!reportEl2) return;

        setDownloadLoading(true); // ← Start loading
        try {
            const reportEl = reportEl2.cloneNode(true);
            const pageEls = reportEl.querySelectorAll(".pdf-page");

            pageEls.forEach((el) => {
                const originalStyle = el.getAttribute("style") || "";
                const cleanedStyle = originalStyle
                    .replace(/visibility\s*:\s*hidden\s*;?/gi, "")
                    .replace(/position\s*:\s*absolute\s*;?/gi, "")
                    .trim();
                el.setAttribute("style", cleanedStyle);
            });

            reportEl.style.position = "absolute";
            reportEl.style.left = "-9999px";
            reportEl.style.top = "0";
            document.body.appendChild(reportEl);

            const pdf = new jsPDF({
                unit: "px",
                format: [794, 1120],
                orientation: "portrait"
            });

            const preloadImages = async () => {
                const images = reportEl.querySelectorAll("img");
                await Promise.all(
                    Array.from(images).map((img) => {
                        if (!img.complete) {
                            return new Promise((resolve) => {
                                img.onload = img.onerror = resolve;
                            });
                        }
                        return Promise.resolve();
                    })
                );
            };

            await preloadImages();

            const SCALE = 1.5;

            for (let i = 0; i < pageEls.length; i++) {
                const canvas = await html2canvas(pageEls[i], {
                    scale: SCALE,
                    useCORS: true,
                    backgroundColor: "#fff",
                    logging: false
                });

                const imgData = canvas.toDataURL("image/jpeg", 0.85);
                if (i > 0) pdf.addPage();
                pdf.addImage(imgData, "JPEG", 0, 0, 794, 1120);
            }

            document.body.removeChild(reportEl);
            pdf.save("Credit-Report.pdf");
        } catch (err) {
            console.error("PDF generation failed:", err);
        } finally {
            setDownloadLoading(false); // ← Stop loading
        }
    };



    useEffect(() => {
        profileApiData({}, (res) => {
            if (res && res.data) {
                setProfileData(res.data)
            }
        })
    }, [])


    useEffect(() => {
        GET_INSIGHTS({}, (result) => {
            if (result && result.data.success) {
                setData(result.data.response);
            }
        });
    }, []);

    useEffect(() => {
        setIsLoading(true);
        postGenericInsights("", (result) => {
            if (result && result.data.success) {
                setMainData(result.data.response);
            }
        });
    }, []);

    const checkType = () => {
        const { totalPayments, onTimePayments } = mainData || {};
        if (totalPayments === 0) {
            setInsightType("type_perfect");
            return;
        }
        if (!totalPayments || !onTimePayments) {
            setInsightType("type_poor"); // Default or fallback value
            return;
        }
        const res = onTimePayments / totalPayments;
        if (res === 1) {
            setInsightType("type_perfect");
        } else if (res < 1 && res >= 0.9) {
            setInsightType("type_good");
        } else if (res < 0.9 && res >= 0.7) {
            setInsightType("type_fair");
        } else if (res < 0.7) {
            setInsightType("type_poor");
        }
        setIsLoading(false)
    };

    const calculateInsightType = () => {
        const { limitUtilized = 0, creditLimit = 1 } = mainData;
        const keyPer = (limitUtilized / creditLimit) * 100;
        if (keyPer < 30) return "type_perfect";
        if (keyPer < 70) return "type_high";
        return "type_extreme_high";
    };

    const checkTypeForCreditMix = () => {
        const {
            closedAccounts,
            activeSecureLoanAccounts,
            activeUnsecureLoanAccounts,
            activeCreditCards
        } = mainData || {};
        if (
            activeSecureLoanAccounts >= 1 &&
            activeUnsecureLoanAccounts >= 1 &&
            activeCreditCards >= 1
        ) {
            setInsightTypeCM("type_perfect");
        } else if (
            (
                activeSecureLoanAccounts >= 1 &&
                activeUnsecureLoanAccounts >= 1
            )
            ||
            (
                activeSecureLoanAccounts >= 1 &&
                activeCreditCards >= 1)
            ||
            (
                activeCreditCards >= 1 &&
                activeUnsecureLoanAccounts >= 1)
        ) {
            setInsightTypeCM("type_good");
        } else if (
            activeSecureLoanAccounts >= 1
        ) {
            setInsightTypeCM("type_fair");
        } else if (activeUnsecureLoanAccounts >= 1 || activeCreditCards >= 1 || closedAccounts >= 1) {
            setInsightTypeCM("type_poor");
        }
    };

    useEffect(() => {
        const newInsightType = calculateInsightType();
        if (newInsightType !== insightType) {
            setInsightTypeCU(newInsightType);
        }
    }, [mainData]);

    useEffect(() => {
        checkType()
    }, [mainData])
    useEffect(() => {
        checkTypeForCreditMix()
    }, [mainData])

    // useEffect(() => {

    //     const mainDataReady = mainData && Object.keys(mainData).length > 0;
    //     const dataReady = data && Object.keys(data).length > 0;
    //     const insightsReady = insightType && insightType.length > 0;

    //     if (!isLoading && mainDataReady && dataReady && insightsReady) {
    //         // calculatedDom(reportRef.current)
    //         handleDownload()
    //         // console.log(calculatedDom)
    //     }
    // }, [mainData, data, insightType, isLoading]);


    // Expose handleDownload to parent via ref
    useImperativeHandle(ref, () => ({
        triggerDownload: handleDownload
    }));

    return (
        <div className="pdf-d-container">
            {/* 🔹 Button to Generate PDF */}
            {/* <button
                onClick={handleDownload} className="pdf-btn"
                disabled={downloadLoading}
                style={{
                    opacity: downloadLoading ? .6 : 1
                }}
            >
                {
                    downloadLoading ?
                        <CircularProgress style={{ height: 15, width: 15 }} color="inherit" /> :
                        null
                }
                Download PDF
            </button> */}

            {/* 🔹 Content to Convert to PDF */}
            <div ref={reportRef} className="pdf-container" >

                <PageWrapper>
                    <LandingPage
                        mainData={mainData}
                        isLoading={isLoading}
                    />
                </PageWrapper>
                <PageBreakMediator children={<ReportIndexPage />} />
                <PageBreakMediator>
                    {
                        !isLoading &&
                            mainData &&
                            Object.keys(mainData).length &&
                            Object.keys(data).length > 0 &&
                            Object.keys(profileData).length > 0 &&
                            insightType.length > 0 ? (
                            <ProfileInfoPage
                                mainData={mainData}
                                isLoading={isLoading}
                                profileData={profileData}
                            />
                        ) : (
                            <div>Loading report data...</div>
                        )
                    }
                </PageBreakMediator>
                <PageWrapper>
                    {
                        !isLoading &&
                            mainData &&
                            Object.keys(mainData).length && Object.keys(data).length > 0 &&
                            insightType.length > 0 ? (
                            <ReportAtGlance
                                mainData={mainData}
                                isLoading={isLoading}
                                data={data}
                            />
                        ) : (
                            <div>Loading report data...</div>
                        )
                    }
                </PageWrapper>
                <PageBreakMediator children={<QuickTipsPage />} />
                <PageBreakMediator>
                    {
                        !isLoading &&
                            mainData &&
                            Object.keys(mainData).length && Object.keys(data).length > 0 &&
                            insightType.length > 0 ? (
                            <PaymentPage
                                mainData={mainData}
                                isLoading={isLoading}
                                insightType={insightType}
                            />
                        ) : (
                            <div>Loading report data...</div>
                        )
                    }
                </PageBreakMediator>
                {
                    !isLoading &&
                        mainData &&
                        Object.keys(mainData).length && Object.keys(data).length > 0 ? (

                        mainData?.insightAccountDetails.map((item, index) =>
                            <PageBreakMediator  >
                                <PaymentElementsPage account={item} accountIndex={index + 1} />
                            </PageBreakMediator>
                        )
                    ) : (
                        <div>Loading report data...</div>
                    )
                }

                <PageBreakMediator>
                    {
                        !isLoading &&
                            mainData &&
                            Object.keys(mainData).length && Object.keys(data).length > 0 &&
                            insightType.length > 0 ? (
                            <CreditUtilisationPage
                                mainData={mainData}
                                isLoading={isLoading}
                                insightType={insightTypeCU}
                            />
                        ) : (
                            <div>Loading report data...</div>
                        )
                    }
                </PageBreakMediator>

                <PageBreakMediator>
                    {
                        !isLoading &&
                            mainData &&
                            Object.keys(mainData).length && Object.keys(data).length > 0 &&
                            insightType.length > 0 ? (
                            <CreditMixPage
                                mainData={mainData}
                                isLoading={isLoading}
                                insightType={insightTypeCM}
                                data={data}
                            />
                        ) : (
                            <div>Loading report data...</div>
                        )
                    }
                </PageBreakMediator>

                <PageBreakMediator>
                    {
                        !isLoading &&
                            mainData &&
                            Object.keys(mainData).length && Object.keys(data).length > 0 &&
                            insightType.length > 0 ? (
                            <CreditMixElementsPage
                                mainData={mainData}
                                isLoading={isLoading}
                                insightType={insightType}
                                data={data}
                                elementType={"Secured"}
                            />
                        ) : (
                            <div>Loading report data...</div>
                        )
                    }
                </PageBreakMediator>
                <PageBreakMediator>
                    {
                        !isLoading &&
                            mainData &&
                            Object.keys(mainData).length && Object.keys(data).length > 0 &&
                            insightType.length > 0 ? (
                            <CreditMixElementsPage
                                mainData={mainData}
                                isLoading={isLoading}
                                insightType={insightType}
                                data={data}
                                elementType={"UnSecured"}
                            />
                        ) : (
                            <div>Loading report data...</div>
                        )
                    }
                </PageBreakMediator>
                <PageBreakMediator>
                    {
                        !isLoading &&
                            mainData &&
                            Object.keys(mainData).length && Object.keys(data).length > 0 &&
                            insightType.length > 0 ? (
                            <CreditMixElementsPage
                                mainData={mainData}
                                isLoading={isLoading}
                                insightType={insightType}
                                data={data}
                                elementType={"Credit Card"}
                            />
                        ) : (
                            <div>Loading report data...</div>
                        )
                    }
                </PageBreakMediator>
                <PageBreakMediator>
                    {
                        !isLoading &&
                            mainData &&
                            Object.keys(mainData).length && Object.keys(data).length > 0 &&
                            insightType.length > 0 ? (
                            <EnquiryPage
                                mainData={mainData}
                                isLoading={isLoading}
                                insightType={insightTypeCM}
                                data={data}
                            />
                        ) : (
                            <div>Loading report data...</div>
                        )
                    }
                </PageBreakMediator>


                <PageBreakMediator>
                    {
                        !isLoading &&
                            mainData &&
                            Object.keys(mainData).length && Object.keys(data).length > 0 &&
                            insightType.length > 0 ? (
                            <ReportAnErrorPage
                                mainData={mainData}
                                isLoading={isLoading}
                                insightType={insightTypeCM}
                                data={data}
                            />
                        ) : (
                            <div>Loading report data...</div>
                        )
                    }
                </PageBreakMediator>
            </div>
        </div>
    );
})
export default DownloadCreditReport;

